import { ForecastWorkspace } from '@/components/forecast/workspace/ForecastWorkspace';

export default function PredictionAccuracy() {
  return <ForecastWorkspace initialTab="actuals" />;
}